const LIFESTYLE_IMAGES = [
  'AlfaRomeo_Giulia_2025',
  'AlfaRomeo_Stelvio_2025',
  'AlfaRomeo_Tonale_2025',
  'Audi_A3Limousine_2025',
  'Audi_A3Sportback_2025',
  'Audi_A4Avant_2025',
  'Audi_A6allroadquattro_2025',
  'Audi_A6Avant_2025',
  'Audi_A6etron_2025',
  'Audi_Q2_2025',
  'Audi_Q3_2025',
  'Audi_Q3Sportback_2025',
  'Audi_Q5Sportback_2025',
  'Audi_Q7_2025',
  'Audi_Q8_2025',
  'Audi_S3Limousine_2025',
  'Audi_S3Sportback_2025',
  'BMW_1er_2025_rncnni',
  'BMW_2erActiveTourer_2025',
  'BMW_2erCoupé_2025',
  'BMW_2erGranCoupé_2025',
  'BMW_3erLimousine_2025',
  'BMW_3erTouring_2025',
  'BMW_4erCabrio_2025',
  'BMW_4erGranCoupé_2025',
  'BMW_5erLimousine_2025_npjbf3',
  'BMW_5erTouring_2025',
  'BMW_i7_2025',
  'BMW_iX1_2025',
  'BMW_ix2_2025',
  'BMW_X1_2025',
  'BMW_X2_2025',
  'BMW_X3_2025',
  'BMW_X4_2025',
  'BMW_X5_2025',
  'BMW_X6_2025',
  'BMW_X7_2025',
  'BMW_X7M_2025',
  'BMW_Z4_2025',
  'BYD_Atto2_2025',
  'BYD_Dolphin_2025_fhz8xp',
  'BYD_Seal_2025',
  'BYD_SealUDMI_2025',
  'BYD_Sealion7_2025',
  'Citroen_C3_2025',
  'Citroen_C3Aircross_2025',
  'Citroen_ëC3Aircross_2025',
  'Cupra_Ateca_2025',
  'Cupra_Formentor_2025',
  'Cupra_Leon_2025',
  'Cupra_Terramar_2025',
  'Dacia_Duster_2025',
  'Dacia_Jogger_2025',
  'DS_DS7_2025',
  'Fiat_500C_2025',
  'Hyundai_bayon_2025_qabqsh',
  'Hyundai_i10_2025',
  'Hyundai_i20_2025',
  'Hyundai_i30_2025',
  'Hyundai_Inster_2025',
  'Hyundai_IONIQ5_2025',
  'Hyundai_IONIQ5N_2025',
  'Hyundai_KONAElektro_2025',
  'Hyundai_SantaFe_2025',
  'Hyundai_Staria_2025',
  'Hyundai_Tucson_2025',
  'Jeep_Avenger_2025',
  'Jeep_Compass_2025',
  'Kia_Ceed_2025_hoyztk',
  'Kia_CeedSportswagon_2025_kjo0wy',
  'Kia_EV3_2025_gzyfh5',
  'Kia_EV6_2025_mrvcey',
  'Kia_Sportage_2025',
  'Mazda_3_2025',
  'Mazda_CX30_2025',
  'Mazda_CX60_2025',
  'Mazda_CX80_2025',
  'Mazda_Mazda2Hybrid_2025',
  'Mazda_Mazda6e_2025',
  'Mazda_MX5_2025',
  'MercedesBenz_CLE_2025',
  'MercedesBenz_EKlasse_2025',
  'MercedesBenz_GLA_2025',
  'MercedesBenz_GLB_2025',
  'MercedesBenz_GLC_2025',
  'MercedesBenz_GLCCoupé_2025',
  'MercedesBenz_GLE_2025',
  'MercedesBenz_GLS_2025',
  'MercedesBenz_GLECoupé_2025',
  'MG_HS_2025',
  'MG_MG3_2025',
  'Nissan_JUKE_2025',
  'Nissan_Qashqai_2025',
  'Nissan_XTRAIL_2025',
  'Opel_Astra_2025',
  'Opel_AstraSportsTourer_2025',
  'Opel_Corsa_2025',
  'Opel_Frontera_2025',
  'Opel_Fronterae_2025',
  'Opel_Grandland_2025',
  'Opel_Mokka_2025',
  'Peugeot_2008_2025',
  'Peugeot_208_2025',
  'Peugeot_3008_2025',
  'Peugeot_308_2025',
  'Peugeot_308SW_2025_pnlu7a',
  'Peugeot_5008_2025',
  'Peugeot_e2008_2025',
  'Renault_Austral_2025',
  'Renault_Rafale_2025',
  'Renault_Symbioz_2025',
  'Seat_Arona_2025',
  'Seat_Ateca_2025',
  'Seat_Ibiza_2025',
  'Skoda_Enjaq_2025',
  'Toyota_bZ4X_2025',
  'Toyota_CHR_2025',
  'Toyota_Corolla_2025',
  'Toyota_ProaceCityVerso_2025',
  'Toyota_ProaceVerso_2025',
  'Toyota_YarisCross_2025',
];

export const getLifestyleImage = (brand?: string, model?: string) => {
  if (!brand || !model) {
    return null;
  }

  const key = `${brand.replaceAll(' ', '').replaceAll('-', '')}_${model.replaceAll(' ', '').replaceAll('-', '')}`;
  const uploadedImage = LIFESTYLE_IMAGES.find((image) => image.startsWith(key));
  if (!uploadedImage) {
    return null;
  }

  return `https://res.cloudinary.com/finn-auto/image/upload/relevance/lifestyle/${uploadedImage}`;
};
